import './callWe.scss'
import Bottom from './../components/bottom'
import { useState } from 'react'
import companyUtil from "../../utils/companyUtil";

import { Carousel } from 'antd';
var React = require("react")



//招贤纳士
type propsType = {
    setCurrentIndex:Function,  //修改首页选中下标
}
const Recruit:React.FunctionComponent<propsType>  = (props) => {
    const [textList] = useState([
        "邮箱："+companyUtil.email,
        "座机："+companyUtil.phone,
        "地址："+companyUtil.location,
    ])
    const setCurrentIndex = props.setCurrentIndex

    return(
        <div className="callWeBox" style={{"height":document.documentElement.clientHeight}}>
            <img className="backImg" src={require('./../assets/background/about_us_bg.png').default} alt=""/>
            <div className="contentBigBox">
                <div className="contentBox">
                    <p className="titleText">联系我们</p>
                    <div className="line"></div>
                    {textList.map((item,index)=>{
                        return(
                            <div key={index}>
                                <p className="itemText">{item}</p>
                            </div>
                        )
                    })}
                </div>
            </div>
            <Bottom setPropsCurrentIndex={setCurrentIndex}></Bottom>
        </div>
    )

}

export default Recruit
